/**
 * AdminRoute — gates access to /admin/* routes purely via the dedicated
 * admin email/password (see `lib/adminGate`). The regular user session
 * is INDEPENDENT of admin access — administrators sign in directly at
 * `/admin/login` without needing a normal Neyra account.
 *
 * The existing `isAdminUser(user)` helper is still exported for legacy
 * call-sites that hide admin entry-points inside the regular app.
 */
import { Navigate, useLocation } from "react-router-dom";
import { getUsers } from "@/lib/storage";
import { isAdminGateOpen } from "@/lib/adminGate";

const ADMIN_BOOTSTRAP_EMAIL = (process.env.REACT_APP_ADMIN_EMAIL || "").toLowerCase();

export const isAdminUser = (user) => {
    if (!user) return false;
    // Accept the explicit role flags any backend / admin tool might use.
    const role = String(user.role || "").toLowerCase();
    if (role === "admin" || role === "super_admin") return true;
    if (user.is_admin === true || user.isAdmin === true) return true;
    if (ADMIN_BOOTSTRAP_EMAIL && (user.email || "").toLowerCase() === ADMIN_BOOTSTRAP_EMAIL) {
        return true;
    }
    const all = getUsers();
    if (all.length === 1 && all[0].id === user.id && !all.some((u) => u.role === "admin")) {
        return true;
    }
    return false;
};

const AdminRoute = ({ children }) => {
    const loc = useLocation();
    if (!isAdminGateOpen()) {
        return <Navigate to="/admin/login" state={{ from: loc.pathname }} replace />;
    }
    return children;
};

export default AdminRoute;
